<div style="height: 92vh; width: 100vw; display: flex; justify-content: center; align-items: center;" >
    <div style="text-align: center;"> 
        <img src="/assets/images/shared/check-icon.png" alt="" style="height: 120px; width: 120px; margin-bottom: 10px;"> <br>
        <p style="font-weight: bold;">{{ 'Вашата заявка е приета и се обработва!' }}</p>
        <p style="color: #ADAFBB;">Ако имате допълнителни въпроси относно връщането, моля, свържете се с търговеца.</p>
    </div>
</div>
<!-- <div class="row" style="position: fixed; bottom: 5px; text-align: center; width: 90%; margin: auto; left: 5%;">
    <div class="row justify-content-around;" style="margin-top: 40px;">
        <button type="button" class="btn btn-primary col-5" style="width: 90%; margin: auto; background-color: #E4F2FE; color: #0A69EB;" >Не споделяй</button>
        <button type="button" class="btn btn-primary col-5" style="width: 90%; margin: auto;">Да</button>
    </div>
</div> -->
<div style="position: fixed; bottom: 35px; text-align: center; width: 90%; margin: auto; left: 5%;">
    <button type="button" class="btn btn-primary" style="width: 100%; margin: auto; height: 45px;" (click)="this.goToHome()">Затвори</button>
</div>